module.exports = __webpack_public_path__ + "media/images/icons/dollar-bubble-a3cc45d700089536798f3ba92d5f55e3.svg";